import { defineMessages } from 'react-intl';

export default defineMessages({
    policyCoverages: {
        id: 'wmic-pe-capability-gateway-common-ho-react.WMICHOPolicyCoverages.Policy Level Coverages',
        defaultMessage: 'Policy Level Coverages',
    },
});
